import {
  Monitor,
  CreditCard,
  BarChart3,
  ArrowUpRight,
  Zap,
  Megaphone,
  Smartphone,
  CupSoda,
} from "lucide-react";

import proteinCup from "../assets/proteincups.png";

import "../styles/sections.css";

const Features = () => {
  const features = [
    {
  number: "01",
  icon: <CupSoda size={25} strokeWidth={1.5} />,
  title: "Choose Your Flavour",
  desc: "Explore a range of protein drink flavours from trusted brands, giving customers more choice with every visit.",
},
    {
      number: "02",
      icon: <Monitor size={25} strokeWidth={1.5} />,
      title: "Smart Display",
      desc: "Promote products, special offers, partner campaigns and digital advertisements directly on the machine.",
    },
    {
      number: "03",
      icon: <CreditCard size={25} strokeWidth={1.5} />,
      title: "Smart Payments",
      desc: "Fast and frictionless payments with QR, NFC, Apple Pay and Google Pay.",
    },
    {
      number: "04",
      icon: <BarChart3 size={25} strokeWidth={1.5} />,
      title: "Live Analytics",
      desc: "Track sales, inventory and machine performance with real-time data.",
    },
  ];

  return (
    <section id="features" className="features">

      {/* =========================================
          HEADER
      ========================================= */}

      <div className="features-header">

        <div className="features-tag">
          <span></span>
          FEATURES
        </div>

        <h2>
          More than a vending machine
          <br />
          {/* <em>machine</em> */}
        </h2>

        <p>
          Dagda combines smart dispensing, digital experiences,
          seamless payments and real-time intelligence into one
          connected nutrition platform.
        </p>

      </div>


      {/* =========================================
          FEATURE SHOWCASE
      ========================================= */}

      <div className="features-showcase">


        {/* =========================================
            SMART DISPLAY
        ========================================= */}

        <div className="showcase-screen">

          {/* Screen Header */}

          <div className="screen-header">

            <div>
              <small>DAGDA DISPLAY</small>
              <strong>LIVE</strong>
            </div>

            <div className="status-dot"></div>

          </div>


          {/* Screen Content */}

          <div className="screen-content">

            <span className="screen-label">
              SMART EXPERIENCE
            </span>


            {/* Protein Cup */}

            <div className="protein-cup">

              <div className="protein-glow"></div>

              <img
                src={proteinCup}
                alt="Dagda protein shake"
              />

            </div>


            {/* Heading */}

            <h3>
              Power your
              <br />
              <span>workout.</span>
            </h3>


            <p>
              Fresh protein. Smart technology.
            </p>


            {/* Home Page Link */}

            <a
              href="/"
              className="explore-products"
            >

              <span>
                EXPLORE PRODUCTS
              </span>

              <span className="explore-arrow">
                <ArrowUpRight size={17} />
              </span>

            </a>

          </div>


          {/* Screen Footer */}

          <div className="screen-footer">

            <span>
              CHOOSE PROTEIN 
            </span>

            <span>
              DISPENSE
            </span>

            <span>
              PAY ONLINE
            </span>

          </div>

        </div>


        {/* =========================================
            FEATURES LIST
        ========================================= */}

        <div className="features-list">

          {features.map((feature) => (

            <div
              className="feature-item"
              key={feature.number}
            >

              <div className="feature-number">
                {feature.number}
              </div>


              <div className="feature-icon">
                {feature.icon}
              </div>


              <div className="feature-info">

                <h3>
                  {feature.title}
                </h3>

                <p>
                  {feature.desc}
                </p>

              </div>


              <ArrowUpRight
                className="feature-arrow"
                size={20}
              />

            </div>

          ))}

        </div>

      </div>


      {/* =========================================
          PROMOTION SECTION
      ========================================= */}

      <div className="promotion-section">


        {/* Content */}

        <div className="promotion-content">

          <div className="promotion-icon">
            <Megaphone size={25} />
          </div>

          <span>
            TURN YOUR MACHINE INTO A MEDIA CHANNEL
          </span>

          <h2>
            Promote.
            <br />
            <em>Engage. Convert.</em>
          </h2>

          <p>
            Use Dagda's smart display to showcase promotions,
            products, partner campaigns and digital advertising
            directly where your customers are already engaging.
          </p>

        </div>


        {/* Advertisement Screen */}

        <div className="promotion-screen">

          <div className="ad-top">

            <span>
              DAGDA × FITNESS
            </span>

            <span>
              01 / 03
            </span>

          </div>


          <div className="ad-content">

            <small>
              SPECIAL OFFER
            </small>

            <h3>
              GET YOUR
              <br />
              <strong>PROTEIN.</strong>
            </h3>


            <div className="offer">

              <span>
                Launching Soon 
              </span>

              <strong>
                Stay tuned
              </strong>

            </div>


            <div className="qr-placeholder">
              <span>
                SCAN
              </span>
            </div>

          </div>


          <div className="ad-bottom">

            <span>
              LIMITED TIME
            </span>

            {/* <span>
              SCAN TO CLAIM
            </span> */}

          </div>

        </div>

      </div>


      {/* =========================================
          BOTTOM BENEFITS
      ========================================= */}

      <div className="feature-benefits">

        <div>
          <Zap size={20} />
          <span>FAST & INTELLIGENT</span>
        </div>

        <div>
          <Smartphone size={20} />
          <span>CONNECTED EXPERIENCE</span>
        </div>

        <div>
          <Monitor size={20} />
          <span>DIGITAL PROMOTIONS</span>
        </div>

        <div>
          <BarChart3 size={20} />
          <span>REAL-TIME INSIGHTS</span>
        </div>

      </div>

    </section>
  );
};

export default Features;